import { render, staticRenderFns } from "./PointSelect.vue?vue&type=template&id=65c26671"
import script from "./PointSelect.vue?vue&type=script&lang=js"
export * from "./PointSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports